import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { PrePostTripDetails } from './trip-information.model';

@Injectable()
export class TripService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetTripHistoryList(input: DataListModel): Observable<IAPIResponse> {
    let getTripHistoryUrl = WeGoConfig.API_GET_TRIP_HISTORY_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getTripHistoryUrl =
    getTripHistoryUrl + '?' + queryStringDataListModel;
    return this.http
      .get(getTripHistoryUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetTripInformationByHashId(
    tripHashId: string,
  ): Observable<IAPIResponse> {
    let gettripUrl = WeGoConfig.API_GET_TRIP_INFORMATION + '?tripHashId=' + tripHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(gettripUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public SaveTripAnswer(
    prePostTripDetails: PrePostTripDetails
  ): Observable<IAPIResponse> {
    let body = prePostTripDetails;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(WeGoConfig.API_POST_TRIP_ANSWER, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetHeaderX(accept?: string, content?: string) {
    let acceptType = accept || "application/json";
    let contentType = content || "application/json";
    let access_token = localStorage.getItem("access_token");
    let authorization = access_token ? "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6IjI4MGJiYmZlLTY1NjUtMTFlYi04YjlkLTJmYzEzOWRhOWE3MyIsInVzZXJJZCI6ImJiZDhmMzJiLTI0OTctNDVkMi05ZjZmLWFiMzZiZTY3MmY2NiIsImJhY2tvZmZpY2VJZCI6IjE1OTkwIiwicGVybWlzc2lvbnMiOiJBZGFwdGVyR2F0ZXdheS5MaXN0QWRhcHRlcnMsQm9va2luZy5DcmVhdGVCb29raW5nLERhbWFnZS5SZXBvcnREYW1hZ2UsRGFtYWdlLkdldERhbWFnZSxEYW1hZ2UuTGlzdERhbWFnZXMsQm9va2luZy5TdGFydEJvb2tpbmciLCJiYWNrb2ZmaWNlUm9sZUlkcyI6IiIsIm5iZiI6MTY0MTIxODA1NCwiZXhwIjoxNjQxMjQ2ODU0LCJpYXQiOjE2NDEyMTgwNTR9.PH0vGsVCjwu3ndy029pjnFK0z8H23_5ZHEyrvClMse4" : "";
    let language = localStorage.getItem("language");
    let accept_language = language ? language : "en";
    let refresh = localStorage.getItem("refresh_token");
    let refresh_token = refresh ? refresh : "";
    let currentRole = localStorage.getItem("current_role");
    let current_role = currentRole ? currentRole : "";
    let computerId = localStorage.getItem("computerId");

    let headers = new Headers({
      "Content-Type": contentType,
      Accept: acceptType,
      Authorization: authorization,
      "Accept-Language": accept_language,
      RefreshToken: refresh_token,
      CurrentRole: current_role,
      ComputerId: computerId
    });

    return headers;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trip/models/trip.service.ts